module.exports = __webpack_public_path__ + "img/wechatIcon2.dfb796f7.png";